import { FILTER_CUSTOMERS } from "../../actions/actionTypes";

const initialState = {
   customers:[],
   loading:false
};

const reducer = (state=initialState, action)=>{
    switch(action.type){
        case FILTER_CUSTOMERS.REQUEST:
            return { ...state, customers: [], loading: true };
        case FILTER_CUSTOMERS.FAILURE:
            return { ...state, customers: [], loading: false };
        case FILTER_CUSTOMERS.SUCCESS:
            return {...state,customers: action.data,loading: false};
        default:
            return state
    }
}

export default reducer;